export const date_options = [
    {
        label: 'All Days',
        value: 'all'
    },     
    {
        label: 'Wed - Sep 3',
        value: '2025-09-03'
    }, 
    {
        label: 'Thu - Sep 4',
        value: '2025-09-04'
    }, 
    {
        label: 'Fri - Sep 5',
        value: '2025-09-05'
    }
]

export const date_options_cal = [
    {
        label: 'Wed - Sep 3',
        value: '2025-09-03'
    }, 
    {
        label: 'Thu - Sep 4',
        value: '2025-09-04'
    }, 
    {
        label: 'Fri - Sep 5',
        value: '2025-09-05'
    }
]

export const skill_level_options = [
    {
        label: 'All Skill Levels',
        value: 'all'
    },
    {
        label: 'Open to All Levels',
        value: 'Open to All Levels'
    },
    {
        label: 'Advanced',
        value: 'Advanced'
    }
]

export const availability_options = [
    {
        label: 'All Availability',
        value: 'all'
    },
    {
        label: 'In Person Only',
        value: 'in_person'
    },
    {
        label: 'On Demand',
        value: 'on_demand'
    }
]

export const seating_options = [
    {
        label: 'All Seating',
        value: 'all'
    },
    {
        label: 'Open Seating',
        value: 'open'
    },
    {
        label: 'Reservation Required',
        value: 'reservations'
    },
]

// A synthetic "Session Type" option for the viewer's own custom events, shown
// only on My Schedule (UNB-582). It deliberately mimics the shape of a real tag
// from /api/v1/session-tags ({ id, name, type }) so the filter drawer can list
// it alongside them and sort it into place by name.
//
// It is NOT a catalog tag, and nothing on the server knows this id. That's what
// makes it work: My Events never reach the server's session list — the agenda
// merges them in client-side (see withEvents in agenda.vue) — so selecting this
// matches zero catalog sessions, the feed comes back empty, and the merged My
// Events are all that's left. Selecting it alongside real types gives the union,
// which is the same OR behaviour the other type checkboxes have.
export const MY_EVENT_TYPE = {
    id: 'my-event',
    name: 'My Event',
    type: 'Session Type',
};

export const date_options_2026 = [
    {
        label: 'All Days',
        value: 'all'
    },
    {
        label: 'Tue - Sep 15 (Partner Day)',
        value: '2026-09-15'
    },
    {
        label: 'Wed - Sep 16',
        value: '2026-09-16'
    },
    {
        label: 'Thu - Sep 17',
        value: '2026-09-17'
    },
    {
        label: 'Fri - Sep 18',
        value: '2026-09-18'
    }
]

export const date_options_cal_2026 = [
    {
        label: 'Tue - Sep 15 (Partner Day)',
        value: '2026-09-15'
    },
    {
        label: 'Wed - Sep 16',
        value: '2026-09-16'
    },
    {
        label: 'Thu - Sep 17',
        value: '2026-09-17'
    },
    {
        label: 'Fri - Sep 18',
        value: '2026-09-18'
    }
]

// Conference timezone per year. 2025 INBOUND was in Pacific (SF);
// INBOUND 26 moves to Eastern (NYC). New years should add an entry here
// rather than introducing a fork in each component.
const CONFERENCE_TIMEZONES = {
    2025: { tz: 'America/Los_Angeles', label: 'PT' },
    2026: { tz: 'America/New_York',    label: 'ET' },
};
const DEFAULT_CONFERENCE_TZ = { tz: 'America/New_York', label: 'ET' };

const yearKey = (year) => {
    const n = typeof year === 'number' ? year : parseInt(year, 10);
    return Number.isFinite(n) ? n : null;
};

export function getConferenceTimezone(year) {
    const key = yearKey(year);
    return (key !== null && CONFERENCE_TIMEZONES[key]?.tz) || DEFAULT_CONFERENCE_TZ.tz;
}

export function getConferenceTimezoneLabel(year) {
    const key = yearKey(year);
    return (key !== null && CONFERENCE_TIMEZONES[key]?.label) || DEFAULT_CONFERENCE_TZ.label;
}

// Partner Day is the registration-gated first day of the conference. Until
// the login + ticket-tier check ships, agenda views and the endpoint hide
// sessions on this date unless the block is in `randomize` preview mode.
const PARTNER_DAYS = {
    2026: '2026-09-15',
};

export function getPartnerDay(year) {
    return PARTNER_DAYS[yearKey(year)] || null;
}

// Current live event year. Sessions from prior years are treated as archived
// (no date/time/location or capacity treatment shown for them).
export const CURRENT_EVENT_YEAR = 2026;

// A session belongs to a past event year.
export function isArchivedSession(session) {
    const y = session?.year;
    return y != null && y < CURRENT_EVENT_YEAR;
}

// Agenda time-range window (whole hours, conference-local). The slider span,
// the API time filter, and the calendar grid all derive from these so the
// front end and back end can't drift apart.
export const AGENDA_START_HOUR = 9;
export const AGENDA_END_HOUR = 20;
export const AGENDA_WINDOW_HOURS = AGENDA_END_HOUR - AGENDA_START_HOUR;


// Is this session available on demand?
//
// TWO SOURCES, deliberately OR-ed. `on_demand` is Sessionboard's checkbox
// (custom field `on_demand`, column added in 0024). `livestream` is the legacy
// flag, true on exactly 37 production rows — every one an archived 2025 session
// dated Sep 3-5 2025, and none in the 2026 catalog.
//
// SHARED because three cards draw the on-demand glyph from three separate
// templates AND two server-side filters select on it (`availability=on_demand`
// and the `on_demand` param). Those filters used to read `livestream` alone, so
// leaving them would have meant a 2026 session showing the icon and then not
// appearing under the filter that claims to list exactly those sessions —
// one session giving two answers, which is the UNB-748 shape.
//
// Pure and Vue-free, so it is safe on the Worker's cold start path as well as
// in a component.
export function isSessionOnDemand(session) {
    return !!(session?.on_demand || session?.livestream);
}
